(function (app) {
    var roles = [
        { Name: "Administrator", Id: 2 },
        { Name: "Advisor", Id: 1 },
        { Name: "Front Office", Id: 3 }
    ];

    var role = {
        Id: 1,
        Name: "Advisor",
        Description: "Allows the user to view and edit most things except what is on the administration page.",
        Users: [
            { Id: 1, FirstName: "Greg", LastName: "Schaefer", ProfilePictureLocation: "/Images/profile2.png" },
            { Id: 2, FirstName: "Holly", LastName: "Adams", ProfilePictureLocation: "/Images/profilepicture8.jpg" },
            { Id: 3, FirstName: "Craig", LastName: "Holliday", ProfilePictureLocation: "/Images/profilepicture4.jpg" }
        ],
        CanCreateManageTeamsPermission: true,
        CanCreateManageWorkflowsPermission: true
    };

    app.provider("roleApi",
    [
        function () {
            this.$get = [
                "$q", "crmApiGateway", function ($q, crmApiGateway) {
                    var service = {};

                    service.getAll = function () {
                        return $q.when(roles);
                        //return crmApiGateway.getArray("/Roles");
                    };

                    service.get = function (roleId) {
                        return $q.when(role);
                        // return crmApiGateway.get("/Roles/" + roleId);
                    };

                    service.add = function (role) {
                        return $q.when(role);
                        // return crmApiGateway.post("/Roles", role);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); // jshint ignore:line